/**
 * Builds a Splunk search URL for the given search query and time-range params.
 */
export const buildSplunkUrl = (query: string, timeRangeParams: string): string =>
	`https://splunk.paas-inf.net/en-US/app/search/search?q=search%20${encodeURIComponent(
		query,
	)}&display.page.search.mode=smart${timeRangeParams}`;
